import { computed } from "vue";
import { useRoute } from "vue-router";

export function useParams() {
    const route = useRoute();

    const campaignId = computed(() => {
        return route.params.campaignId as string;
    });

    const clientId = computed(() => {
        return route.params.clientId as string;
    });

    return {
        campaignId,
        clientId
    };
}
